__turbopack_context__.v({
  "blink": "CtaButton-module-scss-module__1C0gdW__blink",
  "borderWhite": "CtaButton-module-scss-module__1C0gdW__borderWhite",
  "button": "CtaButton-module-scss-module__1C0gdW__button",
  "noBorder": "CtaButton-module-scss-module__1C0gdW__noBorder",
});
